// extracted by mini-css-extract-plugin
module.exports = {"container":"test-contructor_container__1HxgH","lg":"test-contructor_lg__30Fp1","full":"test-contructor_full__2brxj"};